import { render } from "./index.vue?vue&type=template&id=d4a8bd4c"
const script = {}

import exportComponent from "/data/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__